import React from "react";
import { Card, Grid, Button } from "@material-ui/core";
import ApolloClient from "apollo-client";
import "./painelCadastro.css";
import { statusChip } from "./statusPainelCadastro";
import { exigeTermoAdesao } from "./termoAdesaoOperadora";

interface Descricao {
  descricao?: string | null;
}

export interface LinhaPainelCadastro {
  operadora?: { codoperadora?: number | null; nome?: string | null; estabelecimentoCadastroTaxa?: string | null } | null;
  statusCarteira?: Descricao | null;
  statusTermo?: Descricao | null;
  statusEC?: Descricao | null;
  statusTaxa?: Descricao | null;
}

interface Acao {
  texto: string;
  classe: string;
  onClick: () => void;
  disabled?: boolean;
}

interface CardItemProps {
  label: string;
  text?: string;
  acoes?: Acao[];
}

const CardItems: React.FC<CardItemProps> = ({ label, text, acoes }) => {
  const largura = acoes && acoes.length > 1 ? 12 : 6;
  return (
    <Grid container spacing={2} xs={12} data-item={label}>
      <Grid item xs={largura}>
        <b>{label}:</b>
      </Grid>
      <Grid
        item
        xs={largura}
        style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap", gap: 8 }}
      >
        {acoes
          ? acoes.map((acao) => (
              <Button
                key={acao.texto}
                size="small"
                disabled={acao.disabled}
                style={{ padding: 0, paddingLeft: 8, paddingRight: 8, maxHeight: 25 }}
                className={`painelDocumentosBotao ${acao.classe}`}
                onClick={acao.onClick}
              >
                {acao.texto}
              </Button>
            ))
          : text}
      </Grid>
    </Grid>
  );
};

interface Props {
  linha: LinhaPainelCadastro;
  client: ApolloClient<any>;
  download: (tipoDocumento: string, client: ApolloClient<any>, codoperadora: number) => void;
  upload: (codoperadora: number, tipoDocUpload: string) => void;
  cadastrarEC: (nomeOperadora: string, codOperadora: number) => void;
  cadastrarTaxa: (nomeOperadora: string, codOperadora: number, mensagem: string) => void;
}

const CardTableMobile: React.FC<Props> = ({ linha, client, download, upload, cadastrarEC, cadastrarTaxa }) => {
  const nome = linha.operadora!.nome!;
  const cod = linha.operadora!.codoperadora!;
  const autorizacao = statusChip(linha.statusCarteira?.descricao, "documento");
  const adesao = statusChip(linha.statusTermo?.descricao, "documento");
  const ec = statusChip(linha.statusEC?.descricao, "cadastro");
  const taxa = statusChip(linha.statusTaxa?.descricao, "cadastro");
  const baixar = (tipo: string): Acao => ({ texto: "Baixar", classe: "download", onClick: () => download(tipo, client, cod) });

  return (
    <Grid container spacing={2} xs={12}>
      <Card elevation={20} style={{ width: "100%", marginBottom: 25, padding: 15 }}>
        <CardItems label="Operadora" text={nome} />
        <CardItems label="Instrução" acoes={[{ texto: "Visualizar", classe: "download", onClick: () => download("INSTRUCAO", client, cod) }]} />
        <CardItems
          label="Termo de autorização"
          acoes={[
            baixar("CARTA_INTERVAN"),
            { texto: autorizacao.label, classe: autorizacao.classe, onClick: () => upload(cod, "CARTA_INTERVAN") },
          ]}
        />
        {exigeTermoAdesao(linha.statusTermo?.descricao) && (
          <CardItems
            label="Termo de adesão"
            acoes={[baixar("TERMO_ADESAO"), { texto: adesao.label, classe: adesao.classe, onClick: () => upload(cod, "TERMO_ADESAO") }]}
          />
        )}
        <CardItems label="Código de estabelecimento" acoes={[{ texto: ec.label, classe: ec.classe, onClick: () => cadastrarEC(nome, cod) }]} />
        <CardItems
          label="Taxas"
          acoes={[
            {
              texto: taxa.label,
              classe: taxa.classe,
              disabled: linha.statusTaxa?.descricao === "aprovado",
              onClick: () => cadastrarTaxa(nome, cod, linha.operadora!.estabelecimentoCadastroTaxa!),
            },
          ]}
        />
      </Card>
    </Grid>
  );
};

export default CardTableMobile;
